import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { SuiviDTO } from "src/app/mon-portefeuille/core/model/suivi-dto";
import { SuiviDossierService } from "src/app/mon-portefeuille/core/service/suivi-dossier.service";
import { SommeTempsDTO } from "src/app/mon-portefeuille/core/model/somme-temps-dto";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AssignerDossierComponent } from "../../modal/assigner-dossier/assigner-dossier.component";
import { DiagramBpmnComponent } from "../../modal/diagram-bpmn/diagram-bpmn.component";
import { LogAssignationComponent } from "../../modal/log-assignation/log-assignation.component";
import { TacheDetailComponent } from "../../modal/tache-detail/tache-detail.component";
import { ChangerEtapeComponent } from "../../modal/changer-etape/changer-etape.component";
import { MigrerDossierComponent } from '../../modal/migrer-dossier/migrer-dossier.component';
import { BpmnTaskService } from 'src/app/parametrage/core/service/bpmn-task.service';
import { Task } from 'src/app/parametrage/core/model/bpmn/task';
import { ProcessInstanceService } from 'src/app/parametrage/core/service/process-instances.service';
import { ProcessInstances } from 'src/app/parametrage/core/model/bpmn/process-instance';
import { RetournerDossierModalComponent } from '../../modal/retourner-dossier-modal/retourner-dossier-modal.component';

@Component({
  selector: "app-suivi-dossier",
  templateUrl: "./suivi-dossier.component.html",
  styleUrls: ["./suivi-dossier.component.scss"],
})
export class SuiviDossierComponent implements OnInit {
  @Input() requestId: any;
  request: Request;

  suiviList: SuiviDTO[];
  somme: SommeTempsDTO;

  currentTasks: Task[];
  processInstances : ProcessInstances;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private _suiviDossierService: SuiviDossierService,
    private _requestService: RequestService,
    private _bpmnTaskService: BpmnTaskService,
    private _processInstanceService : ProcessInstanceService
  ) {}

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.getSuivi(this.requestId);
    this.getSommeTemps(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
        this.findCurrentTasksByRequestInstanceId(this.request.xmlData);
        this.findCurrentChildrenOrSuperByRequestInstanceId(this.request.xmlData);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSuivi(requestId) {
    this._suiviDossierService.getSuivi(requestId).subscribe(
      (data) => {
        this.suiviList = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSommeTemps(requestId) {
    this._suiviDossierService.getSommeTemps(requestId).subscribe(
      (data) => {
        this.somme = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  dhm(ms) {
    const days = Math.floor(ms / (24 * 60 * 60 * 1000));
    const daysms = ms % (24 * 60 * 60 * 1000);
    const hours = Math.floor(daysms / (60 * 60 * 1000));
    const hoursms = ms % (60 * 60 * 1000);
    const minutes = Math.floor(hoursms / (60 * 1000));
    const minutesms = ms % (60 * 1000);
    const sec = Math.floor(minutesms / 1000);
    return days + " jr: " + hours + " hr: " + minutes + " min: " + sec + " sec";
  }

  assigner(taskId) {
    const modalRef = this.modalService.open(AssignerDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.taskId = taskId;

    modalRef.result.then(
      (data) => {
        this.getSuivi(this.requestId);
        this.getSommeTemps(this.requestId);
      },
      (reason) => {}
    );
  }

  diagramViewer() {
    this._suiviDossierService.getDiagram(this.requestId).subscribe((text) => {
      const modalRef = this.modalService.open(DiagramBpmnComponent, {
        size: "lg",
        backdrop: "static",
        centered: true,
      });

      modalRef.componentInstance.url = [text];

      modalRef.result.then(
        (data) => {},
        (reason) => {}
      );
    });
  }

  logAssignation(taskKey) {
    const modalRef = this.modalService.open(LogAssignationComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.taskKey = taskKey;

    modalRef.result.then(
      (data) => {
        // on close
        this.getSuivi(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  detailTache(taskKey, taskName) {
    const modalRef = this.modalService.open(TacheDetailComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.taskKey = taskKey;
    modalRef.componentInstance.taskName = taskName;

    modalRef.result.then(
      (data) => {
        // on close
        this.getSuivi(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  changeStep(currentTaskId) {
    const modalRef = this.modalService.open(ChangerEtapeComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.currentTaskId = currentTaskId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getSuivi(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }
  
  migrer(currentTaskId) {
    const modalRef = this.modalService.open(MigrerDossierComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.currentTaskId = currentTaskId;
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.processInstanceId = this.request.xmlData;

    modalRef.result.then(
      (data) => {
        // on close
        this.getSuivi(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  retourner() {
    const modalRef = this.modalService.open(RetournerDossierModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getSuivi(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  findCurrentTasksByRequestInstanceId(instanceId) {
    this._bpmnTaskService.findCurrentTasksByRequestInstanceId(instanceId).subscribe(
      (data) => {
        this.currentTasks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  findCurrentChildrenOrSuperByRequestInstanceId(processInstanceId) {
    this._processInstanceService.findCurrentChildrenOrSuperByRequestInstanceId(processInstanceId).subscribe(
      (data) => {
        this.processInstances = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

}
